<template>
  <transition name="fade">
    <div>
      <MyShippingDetails ref="MyShippingDetailsCom" :shippingTabTitle="$t('MyAccount_ShippingDetails_title')"
        :changeAddressTabTitle="$t('MyAccount_ShippingDetails_changeTitle')" :account="{ shipping: addresses }"
        transition="sf-fade" :changeAddressDescription="$t('MyAccount_ShippingDetails_message_title2')"
        :changeButtonText="$t('Change')" :deleteButtonText="$t('Delete')"
        :addNewAddressButtonText="$t('MyAccount_ShippingDetails_Add')"
        :updateAddressButtonText="$t('MyAccount_ShippingDetails_Update')" :selectLabel="$t('Country')"
        :shipingTabDescription="$t('MyAccount_ShippingDetails_message_title')"
        :countries="GuoJiaGetters.getGuoJiaStringList(countries)" @update:shipping="saveAddress"
        @delete-address="removeAddress" />
      <paginate v-if="total > 1" v-model="QueryParams.page" :page-count="total" :margin-pages="2" :page-range="5"
        :container-class="'sf-pagination products__pagination'" :activeClass="'current'"
        :page-link-class="'sf-pagination__item'" :prev-link-class="'sf-pagination__item'"
        :next-link-class="'sf-pagination__item'" :break-view-link-class="'break-view-link'" :no-li-surround="true"
        @input="changePageNo" hidePrevNext>
      </paginate>
    </div>
  </transition>
</template>
<script>
import { SfTabs, SfButton, SfIcon } from '@storefront-ui/vue';
import UserShippingAddress from '~/components/UserShippingAddress';
import ShippingAddressForm from '~/components/MyAccount/ShippingAddressForm';
import MyShippingDetails from '~/components/MyShippingDetails';

import { useUserShipping, userShippingGetters, useGuoJia, GuoJiaGetters, useShipping } from '@bee-hole/coms';
import { ref, computed, onMounted } from '@nuxtjs/composition-api';
import { useUiNotification } from '~/composables';
import { usePreviewOrderStore } from '~/stores/previewOrder';
import Paginate from '~/components/Paginate';
export default {
  name: 'ShippingDetails',
  components: {
    SfTabs,
    SfButton,
    SfIcon,
    UserShippingAddress,
    ShippingAddressForm,
    MyShippingDetails,
    Paginate
  },
  setup(props, context) {
    const MyShippingDetailsCom = ref();
    const notify = useUiNotification();
    const {
      addAddress,
      deleteAddress,
      updateAddress,
      error
    } = useUserShipping();
    const { load: loadShippingAddress, loading, shipping: shippingResult } = useShipping();
    const QueryParams = ref({page: 1, limit: 5});
    const previewOrderStore = usePreviewOrderStore();
    const { GuoJiaGet, result: countryList } = useGuoJia();
    const addresses = computed(() =>
      userShippingGetters.getAddresses(shippingResult.value)
    );
    const edittingAddress = ref(false);
    const activeAddress = ref({});
    const isNewAddress = computed(() => !activeAddress.value);
    const countries = ref();

    const getShippingList = async () => {
      await loadShippingAddress({ customQuery: QueryParams.value });
    };
    const changeAddress = (address = {}) => {
      activeAddress.value = address;
      edittingAddress.value = true;
    };

    const onError = (error) => {
      console.error('onError', error);
    };

    const removeAddress = async (address) => {
      await deleteAddress({ address });
      await previewOrderStore.reset();
      await getShippingList();
    };
    // { form, onComplete, onError }
    const saveAddress = async (shippingData) => {
      try {
        // return false;
        if (shippingData.addressId) {
          await updateAddress({ address: shippingData });
        } else {
          await addAddress({ address: shippingData });
        }
        if (!error.value?.addAddress?.message && !error.value?.updateAddress?.message) {
          MyShippingDetailsCom.value?.closeEdit();
          notify.send({
            type: 'success',
            message: isNewAddress.value
              ? context.root?.$t('shipping_add_success')
              : context.root?.$t('Api_Update_success')
          });
          getShippingList();
        }
      } catch (error) {
        onError(error);
      }
    };
    const changePageNo = async (page) => {
      QueryParams.value.page = page;
      getShippingList();
    };
    onMounted(async () => {
      await GuoJiaGet();
      countries.value = countryList.value;
      getShippingList();
    });
    return {
      changeAddress,
      updateAddress,
      removeAddress,
      saveAddress,
      userShippingGetters,
      addresses,
      edittingAddress,
      activeAddress,
      isNewAddress,
      countries,
      GuoJiaGetters,
      MyShippingDetailsCom,
      total: computed(() => Math.ceil(shippingResult.value?.total / QueryParams.value.limit) || 1),
      QueryParams,
      changePageNo
    };
  }
};
</script>

<style lang='scss' scoped>
.message {
  font-family: var(--font-family--primary);
  line-height: 1.6;
  font-size: var(--font-size--base);
  margin: 0 0 var(--spacer-base);
}

.shipping-list {
  margin-bottom: var(--spacer-base);
}

.shipping {
  display: flex;
  padding: var(--spacer-xl) 0;
  border-top: 1px solid var(--c-light);

  &:last-child {
    border-bottom: 1px solid var(--c-light);
  }

  &__content {
    flex: 1;
    color: var(--c-text);
    font-size: var(--font-size--base);
    font-weight: 300;
    line-height: 1.6;
  }

  &__actions {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-end;

    @include for-desktop {
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
    }
  }

  &__button-delete {
    color: var(--c-link);

    @include for-desktop {
      margin-left: var(--spacer-base);
    }
  }

  &__address {
    margin: 0;

    p {
      margin: 0;
    }
  }

  &__client-name {
    font-size: var(--font-size--base);
    font-weight: 500;
  }
}

.action-button {
  width: 100%;

  @include for-desktop {
    width: auto;
  }
}

.tab-orphan {
  @include for-mobile {
    ::v-deep .sf-tabs {
      &__title {
        display: none;
      }

      &__content {
        border: 0;
        padding: 0;
      }
    }
  }
}
</style>
